export default "__VITE_ASSET__12Ih0pKW__"